export default __webpack_public_path__ + "static/media/e-learning colored.e6d43840.svg";